/** @jsxImportSource @emotion/react */
import React, { useCallback, useContext } from 'react'
import {
  CHOICE_ID_OK,
  OK_PROMPT_CHOICES,
  ModalPromptContext
} from '@signal/components/ModalPrompt'
import LicenseInformation from './index'

const LicenseInformationWrapper: React.FC = () => <LicenseInformation />

type UseLicenseInformationPopupReturnType = {
  handleShowLicenseInformation: () => void
}

export function useLicenseInformationPopup(): UseLicenseInformationPopupReturnType {
  const { promptCustom } = useContext(ModalPromptContext)
  const handleShowLicenseInformation = useCallback(() => {
    promptCustom({
      choices: OK_PROMPT_CHOICES,
      defaultChoiceId: CHOICE_ID_OK,
      DescriptionComponent: LicenseInformationWrapper
    })
  }, [promptCustom])
  return { handleShowLicenseInformation }
}
